import { render, staticRenderFns } from "./FormInputCheckboxes.vue?vue&type=template&id=d352a3ae&scoped=true&lang=pug"
import script from "./FormInputCheckboxes.vue?vue&type=script&lang=ts"
export * from "./FormInputCheckboxes.vue?vue&type=script&lang=ts"
import style0 from "./FormInputCheckboxes.vue?vue&type=style&index=0&id=d352a3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d352a3ae",
  null
  
)

export default component.exports